"use strict";

define('rs/models/workflow',['rs/models/abstract'], function (AbstractModel) {
  var Workflow = AbstractModel.extend({}, {
    rootURI: '/rs/api/workflow/',
    requestSummary: function requestSummary(documentId) {
      return this.get('summary/document/' + documentId);
    },
    requestStart: function requestStart(id) {
      return this.post('start/' + id);
    },
    requestCancel: function requestCancel(id) {
      return this.post('cancel/' + id);
    }
  });
  return Workflow;
});

